import { useMutation } from '@tanstack/react-query';

export function useCreateTrainingRegisterReportsFileGenerationProcessMutation() {
  return useMutation({
    mutationFn: async ({ fileGenerationProcessParams }) => {
      const response = await axios.post(
        '/training_register_reports/file_generation_processes',
        {
          file_generation_process: fileGenerationProcessParams,
        },
      );
      return response.data;
    },
  });
}
